import { render, staticRenderFns } from "./PetInsurance.vue?vue&type=template&id=0a31e814&scoped=true"
import script from "./PetInsurance.vue?vue&type=script&lang=js"
export * from "./PetInsurance.vue?vue&type=script&lang=js"
import style0 from "./PetInsurance.vue?vue&type=style&index=0&id=0a31e814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31e814",
  null
  
)

export default component.exports